var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-overlay",on:{"click":function($event){return _vm.closeSuccessModal()}}},[_c('div',{staticClass:"context"},[_c('div',{staticClass:"success-logo-container"},[_c('img',{attrs:{"src":_vm.successImage,"alt":"Image icon"}})]),_c('h1',[_vm._v(_vm._s(_vm.successTitle))]),_c('p',[_vm._v(_vm._s(_vm.successMessage))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }